import Vue from "vue";
import api from "../services/api";
import aad from "../services/aad";
import { mapMutations, mapGetters } from "vuex";
import * as VueGoogleMaps from "vue2-google-maps";
import { bus } from "../main";
import axios from "axios";

export default {
	components: {},
	props: {
		fromLogout: Boolean,
	},

	data: function() {
		return {
			loading: false,
			loadingSilentLogin: false,
			company: "", //"test1",
			userName: "", //"manager",
			password: "", //"admin",

			//Azure AD login
			useAAD: false,

			//temp password
			tmpPassword: "",
			confirmPassword: "",
			isTmpPassword: false,
			showDialogInfoFirstAccess: false,

			//reset credentials
			showDialogResetCreds: false,
			resetCredsCompany: "", //"test1"
			resetCredsUserName: "", //"manager"
			resetCredsLoading: false,
			resetCredsError: false,
			resetCredsErrorMsg: "",

			//two factor authentication
			isTwoFactorAuth: false,
			oneTimePassword: "",

			locRefreshRealTimeMap: 300,

			//trips
			tripsShowMap: false,
			tripsShowBottmoGrid: false,

			//diagnostic
			diagnosticShowMap: false,
			diagnosticShowBottomGrid: false,

			//alarms
			alarmsShowMap: false,
			alarmsShowBottomGrid: false,

			//Generals
			defaultPageSize: 25,
			showTrafficOnMap: false,
			showSatOnMap: false,
			showPoiOnMap: false,
			showExportData: false,

			loginError: false,
			loginErrorMsg: "",

			slide: 0,
			sliding: null,

			//SSO from Fleeway
			fleewayToken: null,

			activeDirectoryEnabled: false,
			azureADApplicationId: "",
			azureADAuthority: "",
			azureActiveDirectoryEnabled: false
		};
	},

	created() {
		var self = this;
		bus.$emit("show-spinner-loading");

		console.log(this.fromLogout);

		if (this.$route.query && this.$route.query.token) {
			//bus.$emit("show-spinner-loading");
			this.fleewayToken = this.$route.query.token;
			this.login();
		}

		api.loginConfiguration()
			.then(res => {
				if (res && res.data) {
					// login congiguration say if azureAd is enabled... if not it check for local AD integration
					if (res.data.azureActiveDirectoryEnabled) {
						self.useAAD = true;
						self.azureADApplicationId = res.data.azureADApplicationId;
						self.azureADAuthority = res.data.azureADAuthority;
					} else if (res.data.activeDirectoryEnabled && !self.fromLogout) {
						self.loading = true;
						self.loadingSilentLogin = true;

						self.company = "xxxxxx";
						self.userName = "xxxxxxxxxxxxxxxxxx";
						self.password = "xxxxxxxxxxxxx";

						var xs = axios.create({
							baseURL: res.data.silentLoginUrl
						});

						xs.get("/token", { withCredentials: true })
							.then(response => {
								if (response && response.data) {
									self.fleewayToken = response.data;
									self.login();
								} else {
									self.company = "";
									self.userName = "";
									self.password = "";

									self.loadingSilentLogin = false;
									self.loading = false;

									bus.$emit("hide-spinner-loading");
								}
							})
							.catch(err => {
								self.company = "";
								self.userName = "";
								self.password = "";
								self.loadingSilentLogin = false;
								self.loading = false;
								bus.$emit("hide-spinner-loading");
								console.log(err);
							});
					}
				}
				bus.$emit("hide-spinner-loading");
			})
			.catch(err => {
				bus.$emit("hide-spinner-loading");
			});
	},

	/* metodi */
	methods: {
		...mapMutations(["settings"]),
		onSlideStart(slide) {
			this.sliding = true;
		},
		onSlideEnd(slide) {
			this.sliding = false;
		},

		onLogin(useAAD) {
			var self = this;
			this.loginError = false;
			if (useAAD === true && !this.company) {
				this.loginError = true;
				this.loginErrorMsg = "L'azienda è obbligatoria";
				return;
			}
			if (useAAD === true) {
				self.useAAD = true;

				bus.$emit("show-spinner-loading");
debugger;
				self.loginError = false;
				self.loginErrorMsg = "";
				aad.authenticate(this.company, this.azureADApplicationId, this.azureADAuthority)
					.then(loginResponse => {
						self.setViewConfig();
						// var xs = axios.create({
						// 	baseURL: process.env.VUE_APP_SILENT_LOGIN_URL
						// });

						// var data = {
						// 	company: self.company,
						// 	token: loginResponse.idToken
						// };

						// xs.post("/login-aad", data, { withCredentials: false })
						// 	.then(response => {
						// 		self.fleewayToken = response.data;
						// 		self.login();
						// 	})
						// 	.catch(err => {
						// 		self.loginError = true;
						// 		self.loginErrorMsg = "Credenziali non valide.";
						// 		self.loading = false;
						// 	});
					})
					.catch(err => {
						bus.$emit("hide-spinner-loading");
						self.loginError = true;
						self.loginErrorMsg = "Credenziali non valide.";
						self.loading = false;
					});
			} else if (this.isTwoFactorAuth) this.verify();
			else this.login();
		},

		login() {
			if (this.isTmpPassword) {
				this.setNewPassword();
				return;
			}

			var self = this;
			self.loading = true;
			self.loginError = false;
			self.loginErrorMsg = "";

			var loginData = {};
			if (this.fleewayToken != null) {
				loginData = {
					token: this.fleewayToken
				};
			} else {
				loginData = {
					company: this.company,
					userName: this.userName,
					password: this.password
				};
			}

			this.$store
				.dispatch("login", loginData)
				.then(data => {
					self.setViewConfig();
				})
				.catch(err => {
					if (err && err.response && err.response.data && err.response.data.error === "E01") {
						//TMP PASSWORD MANAGEMENT
						self.tmpPassword = self.password;
						self.password = "";
						self.isTmpPassword = true;
						self.showDialogInfoFirstAccess = true;
					} else if (err && err.response && err.response.data && err.response.data.error === "E02") {
						// 2FA
						self.isTwoFactorAuth = true;
						// self.loginError = true;
						// self.loginErrorMsg = err.response.data.message;
						bus.$emit("successNotification", err.response.data.message);
					} else if (err && err.response && err.response.data && err.response.data.error === "E03") {
						let errors = {
							messages: [{ type: "error", text: err.response.data.message }]
						};
						bus.$emit("responseNotification", errors);
					} else {
						self.loginError = true;
						self.loginErrorMsg = "credenziali non valide";
					}

					if (self.loadingSilentLogin) {
						self.company = "";
						self.userName = "";
						self.password = "";
						self.loadingSilentLogin = false;
					}

					self.loading = false;
				})
				.finally(res => {
					//self.loading = false;
				});
		},

		setNewPassword() {
			var self = this;
			self.loading = true;
			self.loginError = false;
			self.loginErrorMsg = "";

			api.setNewPassword(self.company, self.userName, self.tmpPassword, self.password, self.confirmPassword)
				.then(res => {
					self.tmpPassword = "";
					self.password = "";
					self.confirmPassword = "";
					self.isTmpPassword = false;
					bus.$emit("successNotification", "Modifica avvenuta con successo!");
				})
				.catch(err => {
					self.loginError = true;
					self.loginErrorMsg = (err && err.response && err.response.data && err.response.data.message) || "credenziali non valide";
				})
				.finally(res => {
					self.loading = false;
				});
		},

		setViewConfig() {
			var self = this;

			api.getViewConfig("globals ").then(res => {
				self.settings(res);

				try {
					VueGoogleMaps.loadGmapApi({
						key: res.maps.apiKey,
						libraries: "places,drawing,visualization"
					});
				} catch (ex) {}

				try {
					// show info about client and server versions
					const clientVersion = process.env.VUE_APP_VERSION;
					const apiVersion = res.apiVersion;
					console.log("Running on gui '" + clientVersion + "' and api '" + apiVersion + "'.");
				} catch (ex) {}

				self.$router.push({
						name: "dashboard"
					});
				// self.$nextTick(function() {
				// 	//self.loading = false;

					
				// });
			});
		},

		resetCreds() {
			var self = this;
			self.resetCredsLoading = true;
			self.resetCredsError = false;
			self.resetCredsErrorMsg = "";

			api.resetPassword(self.resetCredsCompany, self.resetCredsUserName)
				.then(res => {
					self.resetCredsCompany = "";
					self.resetCredsUserName = "";
					self.showDialogResetCreds = false;
					bus.$emit("successNotification", "Password temporanea inviata.");
				})
				.catch(err => {
					self.resetCredsError = true;
					self.resetCredsErrorMsg = (err && err.response && err.response.data && err.response.data.message) || "credenziali non valide";
				})
				.finally(res => {
					self.resetCredsLoading = false;
				});
		},

		verify() {
			var self = this;
			self.loading = true;
			self.loginError = false;
			self.loginErrorMsg = "";

			var verifyData = {
				company: this.company,
				userName: this.userName,
				oneTimePassword: this.oneTimePassword
			};

			this.$store
				.dispatch("verify", verifyData)
				.then(data => {
					self.setViewConfig();
				})
				.catch(err => {
					self.loginError = true;
					self.loginErrorMsg = (err && err.response && err.response.data && err.response.data.message) || "credenziali non valide";

					if (self.loadingSilentLogin) {
						self.company = "";
						self.userName = "";
						self.password = "";
						self.oneTimePassword = "";
						self.loadingSilentLogin = false;
					}

					self.loading = false;
				})
				.finally(res => {
					//self.loading = false;
				});
		}
	},
	computed: {}
};
